import { render, staticRenderFns } from "./qs4-03.vue?vue&type=template&id=f476e456&scoped=true&"
import script from "./qs4-03.vue?vue&type=script&lang=js&"
export * from "./qs4-03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f476e456",
  null
  
)

export default component.exports